@if (this.chat) {
  <!-- Parent gets "ollie" when it's an Ollie message -->
  <div class="chat-box" [class.ollie]="isOllieMessage">
    <div class="profile-container">
      <ng-container *ngIf="isOllieMessage || isOllieHelp">
        <div class="ollie">
          <img class="ollie-image" src="assets/ollie-eyes.png" />
        </div>
      </ng-container>

      <ng-container *ngIf="isPerson">
        <div class="profile">
          <span>{{ userProfile?.first_name?.[0] }}</span>
          <span>{{ userProfile?.last_name?.[0] }}</span>
        </div>
      </ng-container>
    </div>

    <!-- Child "chat-content" has NO .ollie class => .ollie .chat-content usage in SCSS -->
    <div class="chat-content" [class.empty-stream]="isStreaming && content_array.length === 0">
      <app-message-content [chatData]="chat" [messageType]="messageType">
      </app-message-content>

      @if (isStreaming) {
      <mat-spinner class="chat-spinner" diameter="20"></mat-spinner>
      }
    </div>
  </div>
}

<!-- Feedback and action buttons -->
<div class="ollie-box" *ngIf="isOllieMessage && !isStreaming">
  <!-- Feedback buttons (via loop) -->
  <div class="ollie-feedback-box">
    <div class="feedback-buttons">
      @for (button of actionButtons; track button.class) {
        <button mat-icon-button [class]="button.class" [class.active]="button.active" (click)="button.action()"
          [attr.aria-label]="button.aria" [attr.title]="button.aria">
          <mat-icon>{{ button.icon }}</mat-icon>
        </button>
      }
    </div>
  </div>

  <!-- Utility buttons (manually placed for better layout) -->
  <div class="copy-button">
    <button mat-icon-button class="copy" aria-label="Copy all messages" title="Copy all messages" (click)="copyAll()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
    
  <div class="refresh-button" *ngIf="isLast">
      <button mat-icon-button class="refresh" aria-label="Regenerate response" title="Regenerate response"
        (click)="refresh()" [disabled]="refreshLoading">
        <ng-container *ngIf="!refreshLoading; else loadingTpl">
          <mat-icon>refresh</mat-icon>
        </ng-container>
        <ng-template #loadingTpl>
          <mat-spinner diameter="20"></mat-spinner>
        </ng-template>
      </button>
  </div>
</div>